import axios from 'axios';
import {PageVO} from "@/declares/vo/PageVO";
import {PayRecordSearchDTO} from "@/declares/dto/payCenter/PayRecordSearchDTO";
import {PayRecordSearchVO} from "@/declares/vo/payCenter/PayRecordSearchVO";


export const payRecordApi = {

  async search(form: PayRecordSearchDTO): Promise<PageVO<PayRecordSearchVO>> {
    return axios.post(`/admin/peony/payRecord/search`, form);
  },


  async findByFlowNo(flowNo:string) :Promise<PayRecordSearchVO>{
    return axios.post(`/admin/peony/payRecord/findByFlowNo`, {flowNo});
  },


  /**
   * 手动发起业务回调
   */
  async manualNotify(flowNo:string){
    return axios.post(`/admin/peony/payRecord/manualNotify`, {flowNo});
  }

};
